import { render, staticRenderFns } from "./questionOutline.vue?vue&type=template&id=2449fbfb&scoped=true&"
import script from "./questionOutline.vue?vue&type=script&lang=js&"
export * from "./questionOutline.vue?vue&type=script&lang=js&"
import style0 from "./questionOutline.vue?vue&type=style&index=0&id=2449fbfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449fbfb",
  null
  
)

export default component.exports